import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || null,
    bgColor: searchParams.get('bgColor') || 'rgba(0,0,0,0.0)',
    startFrom: parseInt(searchParams.get('startFrom') || '') || 3,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 10000,
    carousel: searchParams.get('carousel') || '0',
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 10,
    scrollSpeed: searchParams.get('scrollSpeed')
      ? Number(searchParams.get('scrollSpeed')) || 15
      : 15,
    scrollDelayStart: searchParams.get('scrollDelayStart')
      ? Number(searchParams.get('scrollDelayStart'))
      : 3000,
    scrollDelayEnd: searchParams.get('scrollDelayEnd')
      ? Number(searchParams.get('scrollDelayEnd'))
      : 3000,

    authorFontSize: searchParams.get('authorFontSize') || '3.5',
    msgFontSize: searchParams.get('msgFontSize') || '2.8',
  };
};
